import dayjs from 'dayjs/esm';

const locale = {
    name: 'tt',
    weekdays: 'Якшәмбе_Дүшәмбе_Сишәмбе_Чәршәмбе_Пәнҗешәмбе_Җомга_Шимбә'.split('_'),
    months: 'Гыйнвар_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_'),
    weekStart: 1,
    weekdaysShort: 'Якш_Дүш_Сиш_Чәр_Пән_Җом_Шим'.split('_'),
    monthsShort: 'Гын_Фев_Мар_Апр_Май_Июн_Июл_Авг_Сен_Окт_Ноя_Дек'.split('_'),
    weekdaysMin: 'Як_Дү_Си_Чә_Пә_Җо_Ши'.split('_'),
    ordinal: (n) => n,
    formats: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    relativeTime: {
        future: '%s эчендә',
        past: '%s элек',
        s: 'берничә секунд',
        m: 'бер минут',
        mm: '%d минут',
        h: 'бер сәгать',
        hh: '%d сәгать',
        d: 'бер көн',
        dd: '%d көн',
        M: 'бер ай',
        MM: '%d ай',
        y: 'бер ел',
        yy: '%d ел'
    }
};

dayjs.locale(locale, null, true);

export default locale;
